// extracted by mini-css-extract-plugin
export default {"whatsapp":"WhatsAppButton_whatsapp__Pfetn"};